<template>
	<div class="cong-banner">
		<div class="cong-banner-info">
			<h2 class="cong-title">{{title}}</h2>
			<p class="cong-description" v-html="description"></p>
		</div>
	</div>
</template>
<style lang="css">
	.cong-banner-info {
		margin-left: 74px;
		max-width: 448px;
	}
	.cong-banner {
		padding: 32px;
		overflow: hidden;
		border-radius: 4px;
		display: flex;
		position: relative;
		background-color: var(--accent-1);
		background-image: url('https://storage.yandexcloud.net/proektoria-education/static/images/banner-bg.svg');
		background-repeat: repeat-y;
		background-position: right;
	}
	.cong-title {
		margin-bottom: 12px;
		color: #fff;
		font-size: 32px;
		line-height: 115%;
		font-family: "Galiver Sans", sans-serif;
	}
	.cong-description {
		font-size: 16px;
		font-weight: 700;
		color: var(--black-20);
	}
	@media (max-width: 768px) {
		.cong-banner {
			background-image: none;
		}
		.cong-banner-info {
			margin-left: 0;
			max-width: 100%;
		}
	}
</style>
<script>
	export default {
		props: {
			title: {
				type: String,
				default: '',
				required: true,
			},
			description: {
				type: String,
				default: '',
				required: true
			}
		}
	}
</script>
